import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { WLMHero } from '../components/weight-loss-men/WLMHero';
export function WeightLossMenPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2676">
      <Navigation data-id="element-2677" />
      <main data-id="element-2678">
        <WLMHero data-id="element-2679" />
      </main>
      <Footer data-id="element-2680" />
    </div>;
}